export const actionSetLote = (state, action) => {
  state.currentLote = action.payload.lote;
};
